import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { ThemeProvider } from './theme/ThemeContext';
import { AppearanceProvider } from './theme/Appearance';
import './styles.css';
// Loaded after the base sheet on purpose: an @import inside styles.css is
// hoisted above its own rules and could not override them.
import './styles/elevate.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AppearanceProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </AppearanceProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
